import { useQuery } from "@apollo/client";
import { SharingInvitationByInvitationCodeDocument } from "../../../../__generated__/graphql";

export default function useSharingInvitation(invitationCode?: string) {
  const { data, loading, error } = useQuery(
    SharingInvitationByInvitationCodeDocument,
    {
      variables: {
        invitationCode: invitationCode ?? "",
      },
      skip: !invitationCode,
    }
  );

  return { data, loading, error };
}
